import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { M19EnvironmentConfig } from "@front/m19-models/Environment";

@Injectable({
  providedIn: "root",
})
export class EnvironmentService {
  constructor() {}

  getEnvironmentConfig(): M19EnvironmentConfig {
    return environment;
  }
}
